import React from 'react';
import { BpmTable } from './BpmTable';
import { getRatioAsPercentage } from './utils';

export const WinLossUSRegionsTable = ({ regionToWinLoss }) => {
    if (!regionToWinLoss) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(regionToWinLoss);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(regionToWinLoss) {
    const result = {
        rows: [], cols: [
            {
                title: 'Region', field: 'region'
            },
            {
                title: 'Decisions', field: 'decisions'
            },
            {
                title: 'Wins', field: 'wins'
            },
            {
                title: 'Win %', field: 'winPercentage'
            }]
    };

    for (const [key, value] of regionToWinLoss) {
        const row = {
            region: key,
            decisions: value.wins + value.losses,
            wins: value.wins,
            winPercentage: getRatioAsPercentage(value.wins, value.wins + value.losses)
        }
        result.rows.push(row);
    }

    return result;
}